import { render, staticRenderFns } from "./ChargebeeUpsellConfigPV3.vue?vue&type=template&id=116ba67c&scoped=true&"
import script from "./ChargebeeUpsellConfigPV3.vue?vue&type=script&lang=js&"
export * from "./ChargebeeUpsellConfigPV3.vue?vue&type=script&lang=js&"
import style0 from "./ChargebeeUpsellConfigPV3.vue?vue&type=style&index=0&id=116ba67c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ba67c",
  null
  
)

export default component.exports